import { useState, useEffect } from 'react';
import { TextField, IconButton } from '@radix-ui/themes';
import { MagnifyingGlassIcon, Cross2Icon } from '@radix-ui/react-icons';
import { getURLParameter, redirectTo } from '../../utils/CommonUtil';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SearchBox({ placeholder, gotoPage, sortType, className }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const keyword = getURLParameter('keyword');
        setSearchTerm(null !== keyword ? keyword : '');
    }, [location.search]);

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchTerm.trim()) {
            const kw = searchTerm.trim();
            const goTo = (null != sortType)
                ? `${gotoPage}?sort=${sortType}&keyword=${encodeURIComponent(kw)}`
                : `${gotoPage}?keyword=${encodeURIComponent(kw)}`;
            redirectTo(goTo);
        }
    };

    const clearSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSearchTerm('');

        const target = null != sortType
            ? `${gotoPage}?sort=${sortType}`
            : gotoPage;
        navigate(target, { replace: true });
    };

    return (
        <TextField.Root
            className={className}
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleSearch}
        >
            <TextField.Slot>
                <MagnifyingGlassIcon height="14" width="14" />
            </TextField.Slot>
            {searchTerm ? (
                <TextField.Slot>
                    <IconButton
                        type="button"
                        size="1"
                        variant="ghost"
                        aria-label="清除搜索"
                        onPointerDown={(e) => e.preventDefault()}
                        onClick={clearSearch}
                    >
                        <Cross2Icon height="14" width="14" />
                    </IconButton>
                </TextField.Slot>
            ) : null}
        </TextField.Root>
    );
}
